/**
 * تب‌های ناوبری داخلِ هدر — جانشینِ نوارِ کناریِ هاوریِ چپ (WHOSUP-157).
 *
 * چرا تب و نه هاور: کاربر خواست دوستان و برنامه‌ها صفحه‌ی کاملِ خودشون رو
 * داشته باشن، نه یه پنلِ ۳۴۰ پیکسلی. حالا هر مقصد یه لینکِ واقعیه — آدرس
 * توی نوارِ وضعیت دیده می‌شه و «باز کردن در تبِ جدید» کار می‌کنه.
 *
 * تبِ «سیگنال‌ها» (فید) اول بود و بعد به خواستِ صریحِ کاربر حذف شد —
 * «برنامه‌های من» همه‌ی همان برنامه‌ها را (حتی بی‌جواب‌ها) پوشش می‌دهد. فید
 * زیرِ `/signals` سرِ جاش است، فقط از راهِ آدرسِ مستقیم. نقطه‌ی اعلانش هم
 * آمد روی «برنامه‌های من»، و خودِ PlansPage حالا همان دسته‌ها را با دیده
 * شدن «دیده‌شده» می‌زند — وگرنه نقطه‌ای می‌ماند که هیچ‌وقت پاک نمی‌شد.
 *
 * برای مهمان همه‌ی تب‌ها دیده می‌شن — خودِ *بودنشون* بخشی از معرفیِ محصوله —
 * ولی مقصدهای پشتِ ورود اول به /auth می‌رن، با آدرسِ واقعی توی state تا بعدِ
 * ورود همون‌جا برسه (نگاه کن به AuthRoute در routes.tsx). همون الگوی
 * MobileMenu، که نسخه‌ی باریکِ همین ناوبریه.
 *
 * فقط روی صفحه‌ی پهن ساخته می‌شه؛ روی گوشی MobileMenu همین ردیف‌ها رو داره.
 */
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { t, useLocale } from '@/core/lib/i18n';
import type { TourTab } from '@/core/lib/tour';
import type { NotifIndicators } from '@/features/notifications/useNotifIndicators';

interface Props {
  dots: NotifIndicators['dots'];
  guest: boolean;
  /**
   * تبی که تورِ راهنما همین حالا درباره‌اش حرف می‌زند، یا `null` — نگاه کن به
   * `core/lib/tour.ts`. عمداً پراپ است و نه یک `useTour()` داخلِ خودِ این
   * فایل: همان یک منبع در `Shell` خوانده می‌شود و هدر، منوی گوشی و کارتِ
   * تور سه تصویرِ یک حالت می‌مانند.
   */
  point?: TourTab | null;
}

export function HeaderTabs({ dots, guest, point = null }: Props) {
  useLocale();
  const { pathname } = useLocation();

  const tab = (
    to: string, label: string,
    { dot = false, needsAuth = true, alsoOn, tour }: {
      dot?: boolean; needsAuth?: boolean;
      /** مسیرِ دومی که همین تب رو روشن نگه می‌داره (کشف هم `/` است هم `/discover`). */
      alsoOn?: string;
      /** قدمِ تور که به این تب اشاره می‌کنه. */
      tour?: TourTab;
    } = {},
  ) => {
    const bounce = guest && needsAuth;
    const on = pathname === to || pathname === alsoOn;
    return (
      <Link
        to={bounce ? '/auth' : to}
        state={bounce ? { from: to } : undefined}
        className={`htab${on ? ' on' : ''}${tour && point === tour ? ' tour-point' : ''}`}
        aria-current={on ? 'page' : undefined}
      >
        <span>{label}</span>
        {dot ? <span className="navdot" aria-hidden="true" /> : null}
      </Link>
    );
  };

  return (
    <nav className="htabs" aria-label={t('menu')}>
      {tab('/', t('discover'), { needsAuth: false, alsoOn: '/discover', tour: 'discover' })}
      {tab('/plans', t('myPlans'), { dot: dots.signal || dots.event })}
      {tab('/friends', t('friends'), { dot: dots.friend_request, tour: 'friends' })}
    </nav>
  );
}
